import React from 'react';

// SVG Inline
import SVG from 'react-inlinesvg';

import ArrowRightSrc from 'assets/images/icons/DesignSysten2.0/arrows/Arrow Right.svg';
import ArrowLeftSrc from 'assets/images/icons/DesignSysten2.0/arrows/Arrow Left.svg';
import ArrowDownSrc from 'assets/images/icons/DesignSysten2.0/arrows/Arrow Down.svg';
import ArrowUpSrc from 'assets/images/icons/DesignSysten2.0/arrows/Arrow Up.svg';
import Arrow2RightSrc from 'assets/images/icons/DesignSysten2.0/arrows/Arrow 2 Right.svg';
import Arrow2LeftSrc from 'assets/images/icons/DesignSysten2.0/arrows/Arrow 2 Left.svg';
import Arrow2UpSrc from 'assets/images/icons/DesignSysten2.0/arrows/Arrow 2 Up.svg';
import Arrow2DownSrc from 'assets/images/icons/DesignSysten2.0/arrows/Arrow 2 Down.svg';
import DownloadSrc from 'assets/images/icons/DesignSysten2.0/arrows/Download.svg';
// import UploadSrc from 'assets/images/icons/DesignSysten2.0/arrows/Atualizar.svg';
import ShuffleSrc from 'assets/images/icons/DesignSysten2.0/arrows/Shuffle.svg';
import RotasCaminhoSrc from 'assets/images/icons/DesignSysten2.0/arrows/RotasCaminho.svg';
import MinimizarSrc from 'assets/images/icons/DesignSysten2.0/arrows/Minimizar.svg';
import UpdateSrc from 'assets/images/icons/DesignSysten2.0/arrows/Atualizar.svg';
import Update2Src from 'assets/images/icons/DesignSysten2.0/arrows/Atualizar 3.svg';
import RedoSrc from 'assets/images/icons/DesignSysten2.0/arrows/Refazer.svg';
import UndoSrc from 'assets/images/icons/DesignSysten2.0/arrows/Desfazer.svg';
import LoginSrc from 'assets/images/icons/DesignSysten2.0/arrows/Login.svg';
import LogoffSrc from 'assets/images/icons/DesignSysten2.0/arrows/Logoff.svg';
import ExpandSrc from 'assets/images/icons/DesignSysten2.0/arrows/Expandir.svg';
import ArrowOutSrc from 'assets/images/icons/DesignSysten2.0/arrows/Seta Saída.svg';
import ArrowInSrc from 'assets/images/icons/DesignSysten2.0/arrows/Seta Entrada.svg';

interface SVGInlineInterface {
  width?: number | string;
  height?: number | string;
  fill?: string;
}

export const ArrowOut: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={ArrowOutSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const ArrowIn: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={ArrowInSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const ArrowRight: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={ArrowRightSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const ArrowLeft: React.FC<SVGInlineInterface> = ({
  width,
  height,
  fill,
}) => (
  <SVG
    src={ArrowLeftSrc}
    style={{ width, height, fill: '#0094FF' }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);
export const ArrowDown: React.FC<SVGInlineInterface> = ({
  width,
  height,
  fill,
}) => (
  <SVG
    src={ArrowDownSrc}
    style={{ width, height, fill }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);
export const ArrowUp: React.FC<SVGInlineInterface> = ({
  width,
  height,
  fill,
}) => (
  <SVG
    src={ArrowUpSrc}
    style={{ width, height, fill }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Arrow2Right: React.FC<SVGInlineInterface> = ({
  width,
  height,
  fill,
}) => (
  <SVG
    src={Arrow2RightSrc}
    style={{ width, height, fill }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Arrow2Left: React.FC<SVGInlineInterface> = ({
  width,
  height,
  fill,
}) => (
  <SVG
    src={Arrow2LeftSrc}
    style={{ width, height, fill }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);
export const Arrow2Up: React.FC<SVGInlineInterface> = ({
  width,
  height,
  fill,
}) => (
  <SVG
    src={Arrow2UpSrc}
    style={{ width, height, fill }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Arrow2Down: React.FC<SVGInlineInterface> = ({
  width,
  height,
  fill,
}) => (
  <SVG
    src={Arrow2DownSrc}
    style={{ width, height, fill }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);
export const Download: React.FC<SVGInlineInterface> = ({
  width,
  height,
  fill,
}) => (
  <SVG
    src={DownloadSrc}
    style={{ width, height, fill }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

// export const Upload: React.FC<SVGInlineInterface> = ({
//   width,
//   height,
//   fill,
// }) => (
//   <SVG
//     src={UploadSrc}
//     style={{ width, height, fill }}
//     cacheRequests={true}
//     preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
//   />
// );

export const Minimizar: React.FC<SVGInlineInterface> = ({
  width,
  height,
  fill,
}) => (
  <SVG
    src={MinimizarSrc}
    style={{ width, height, fill }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);
export const RotasCaminho: React.FC<SVGInlineInterface> = ({
  width,
  height,
  fill,
}) => (
  <SVG
    src={RotasCaminhoSrc}
    style={{ width, height, fill }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);
export const Shuffle: React.FC<SVGInlineInterface> = ({
  width,
  height,
  fill,
}) => (
  <SVG
    src={ShuffleSrc}
    style={{ width, height, fill }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Expand: React.FC<SVGInlineInterface> = ({
  width,
  height,
  fill,
}) => (
  <SVG
    src={ExpandSrc}
    style={{ width, height, fill }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Update2: React.FC<SVGInlineInterface> = ({
  width,
  height,
  fill,
}) => (
  <SVG
    src={Update2Src}
    style={{ width, height, fill }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);
export const Update: React.FC<SVGInlineInterface> = ({
  width,
  height,
  fill,
}) => (
  <SVG
    src={UpdateSrc}
    style={{ width, height, fill }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Logoff: React.FC<SVGInlineInterface> = ({
  width,
  height,
  fill,
}) => (
  <SVG
    src={LogoffSrc}
    style={{ width, height, fill }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Login: React.FC<SVGInlineInterface> = ({
  width,
  height,
  fill,
}) => (
  <SVG
    src={LoginSrc}
    style={{ width, height, fill }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Undo: React.FC<SVGInlineInterface> = ({ width, height, fill }) => (
  <SVG
    src={UndoSrc}
    style={{ width, height, fill }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);
export const Redo: React.FC<SVGInlineInterface> = ({ width, height, fill }) => (
  <SVG
    src={RedoSrc}
    style={{ width, height, fill }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);
